import React from "react";
class MemberTable extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const rowArray = this.props.rowArray;
        return (
            <table><tr>
            <td></td><th></th><td></td><th>Family</th><th>Character</th><th>AP</th><th>AAP
        </th><th>DP
        </th><th>GS
        </th><th>Level
        </th><th>Class
        </th><th>Last Update
        </th></tr>
                {rowArray}
            </table>
        );
    }
}
export default MemberTable;